import * as React from 'react';
import { useOrgStore } from '../../../hooks/useOrgStore';
import { Routes, useJourneyNavigation } from '../../../routes';
import { SearchableTableWidget } from '../../../widgets/table/SearchableTableWidget';
import { TableColumnStyle } from '../../../widgets/table/TableWidget';
import * as _ from 'lodash';
import { ButtonType, ButtonWidget } from '../../../widgets/buttons/ButtonWidget';
import { SupportRow } from './SupportPage';
import { IntercomTicketModel } from '@journeyapps-platform/lib-journey-core';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react';
import { styled } from '../../../theme';
import { TicketStatus } from '@journeyapps-platform/types-intercom';

export interface SupportTicketTableWidgetProps {
  tickets: IntercomTicketModel[];
}

export const SupportTicketTableWidget: React.FC<SupportTicketTableWidgetProps> = observer((props) => {
  const orgStore = useOrgStore();
  const { navigate } = useJourneyNavigation(Routes.SUPPORT);
  const org = orgStore.current_org!;

  return (
    <SearchableTableWidget<SupportRow>
      columns={[
        {
          key: 'id',
          display: 'ID',
          shrink: true,
          style: TableColumnStyle.SECONDARY
        },
        {
          key: 'subject',
          display: 'Subject',
          style: TableColumnStyle.PRIMARY,
          accessorSearch: (cell) => {
            return cell;
          }
        },
        {
          key: 'updated_at',
          display: 'Last updated',
          accessor: ({ cell }) => {
            return DateTime.fromISO(cell).toRelative()!;
          }
        },
        {
          key: 'severity',
          display: 'Severity',
          shrink: true,
          noWrap: true,
          accessor: ({ cell }) => {
            return _.startCase(cell);
          }
        },
        {
          key: 'status',
          display: 'Status',
          shrink: true,
          accessor: ({ cell, row }) => {
            return <S.Status open={row.model.ticket.status === TicketStatus.OPEN}>{cell}</S.Status>;
          }
        }
      ]}
      onRowSelected={(event, row) => {
        navigate(Routes.SUPPORT_TICKET, {
          org_id: org.org_id,
          ticket_id: row.model.id
        });
      }}
      rows={props.tickets.map((t) => {
        return {
          cells: t.ticket,
          key: t.id,
          model: t
        };
      })}
      controlButtons={[
        <S.Button
          key={'create'}
          type={ButtonType.PRIMARY}
          action={() => {
            navigate(Routes.SUPPORT_CREATE, {
              org_id: org.org_id
            });
          }}
          label="Contact support"
        />
      ]}
    />
  );
});

namespace S {
  export const Status = styled.div<{ open: boolean }>`
    padding: 2px 5px;
    background: ${(p) => (p.open ? p.theme.status.failedBackgroundColor : p.theme.status.successBackgroundColor)};
    border-radius: 3px;
  `;

  export const Button = styled(ButtonWidget)`
    margin-left: 10px;
  `;
}
